import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=4aa995de"
import script from "./DownloadApp.vue?vue&type=script&lang=js"
export * from "./DownloadApp.vue?vue&type=script&lang=js"
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=4aa995de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports